<template>
  <div class="air-table-filter-input">
    <div class="filter-body">
      <div class="top-search">
        <el-input
          v-model="option.data.sVal"
          suffix-icon="el-icon-search"
        />
      </div>
    </div>
    <div class="filter-footer flex jbetween acenter">
      <el-button type="text" class="text-button-filter" @click="resetFilterEvent">重置</el-button>
      <el-button type="primary" @click="confirmFilterEvent">筛选</el-button>
    </div>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'

export default {
  name: 'FilterInput',
  props: {
    params: Object
  },
  data () {
    return {
      size: 'mini',
      isAll: false,
      option: null,
      colValList: [],
      valList: [],
      checkedList: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      const { $table, column } = this.params
      const { fullData } = $table.getTableData()
      const option = column.filters[0]
      const { vals } = option.data
      const colValList = Object.keys(XEUtils.groupBy(fullData, column.property)).map(val => {
        return {
          checked: vals.includes(val),
          value: val
        }
      })
      this.option = option
      this.colValList = colValList
      this.valList = colValList
    },
    searchEvent () {
      const { option, colValList } = this
      this.valList = option.data.sVal ? colValList.filter(item => item.value.indexOf(option.data.sVal) > -1) : colValList
      console.log(this.valList)
    },
    changeAllEvent () {
      const { isAll } = this
      this.valList.forEach(item => {
        item.checked = isAll
      })
    },
    confirmFilterEvent (evnt) {
      const { params, option, valList } = this
      const { data } = option
      const { $panel } = params
      data.vals = valList.filter(item => item.checked).map(item => item.value)
      $panel.changeOption(evnt, true, option)
      $panel.confirmFilter()
    },
    resetFilterEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.vxe-table--filter-wrapper {
  width: min-content;
}
.air-table-filter-input {
  padding: 8px 5px 10px 5px;
  user-select: none;

  .filter-body {
    .top-search {
      ::v-deep .el-input {
        font-size: 12px;
        height: 26px;
        background: #F4F4F4;
        border-radius: 4px;
        min-width: 140px;

        .el-input__inner {
          font-size: 12px;
          border: none;
          height: 26px;
          line-height: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3C475F;
          background: #F4F4F4;
          border-radius: 4px;
        }

        .el-input__icon {
          line-height: 27px;
        }
      }
    }
    .filter-checkbox-group {
      .el-checkbox {
        padding: 0;
      }
    }
  }

  .filter-footer {
    margin-top: 8px;
  }
}
</style>
